import { EnvConfig } from '@config';
import { ApiResponse } from 'types/apiResponse';
import { WellFullDetailsDTO } from 'types/well';

import Client from './client';

class WellsWithWellboreApiClient {
  commonMicroServiceBaseURl = EnvConfig.drillx_common_backend || '';
  accept = 'application/json';
  client: Client;

  constructor() {
    this.client = new Client(this.commonMicroServiceBaseURl, this.accept);
  }

  getWellsWithWellbores = async (): Promise<ApiResponse<WellFullDetailsDTO[]>> => {
    try {
      const url = `/wells/with-wellbores/all`;
      const response = await this.client.get(url);

      return { response };
    } catch (error: any) {
      return { response: [], error };
    }
  };
}

export default new WellsWithWellboreApiClient();
